import { makeCancelAndOkFooterBuilder } from "../../core/widgets/dialogs/footers/footers.js";
import NewDialog from "../../core/widgets/NewDialog/NewDialog.js";
import TreeWidget from "../../core/widgets/tree/TreeWidget/TreeWidget.js";

/**
 * `chartOfAccountsGroupSelectionDialog` displays a dialog to select
 * a group in the chart of accounts tree.
 *
 * It uses a tree similar to the viewers to display the chart of accounts.
 *
 * @param {chartOfAccounts} spec.chartOfAccounts - Chart of accounts to select a group from
 * @param {function} [spec.canBeSelected] - Predicate which given a group returns true
 * if it can be selected
 * @param {chartOfAccountsGroup} [spec.group] - If provided, scroll to the grooup in the tree
 */
export default class ChartOfAccountsGroupSelectionDialog {
	constructor({ title, chartOfAccounts, canBeSelected, group, callback }) {
		this._chartOfAccounts = chartOfAccounts;
		this._group = group;
		this._canBeSelected = canBeSelected || (() => true);
		this._callback = callback;

		this._tree = new TreeWidget({
			data: [this._chartOfAccounts.getMainTree()],
			getLabel: this._labelRenderer,
			canBeSelected: this._canBeSelected,
			autoOpen: 1,
		});

		this._dialog = new NewDialog({
			title,
			body: this._tree,
			footerBuilder: makeCancelAndOkFooterBuilder({
				callback: ({ hide }) => {
					hide();
					callback(this._tree.selectedNode());
				},
			}),
		});
	}

	show() {
		this._dialog.show();

		if (this._group) {
			this._tree.scrollTo(this._group);
		}
	}

	hide() {
		this._dialog.hide();
	}

	_labelRenderer(group) {
		return (html) =>
			html.span(
				{
					klass: { disabled: !this._canBeSelected(group) },
				},
				group.displayLabel(),
			);
	}
}
